module.exports = __webpack_public_path__ + "static/media/guide_Page_16.fab0d280.png";